throw new Error(
  '🚨  redux-starter-kit has been renamed to @reduxjs/toolkit. Please uninstall redux-starter-kit and install @reduxjs/toolkit instead. Learn more about this change here: https://github.com/reduxjs/redux-toolkit/releases/tag/v1.0.4 . Thanks! :)'
)
